import { API_BASE } from "../../../../../utils/baseapiurl";

class UsersMFAAPI {
	async getUsers() {
		try {
			const response = await fetch(`${API_BASE}/users-mfa`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": window.wpApiSettings?.nonce || "",
				},
				credentials: "include",
			});

			const data = await response.json().catch(() => null);

			if (!response.ok) {
				throw new Error(data?.message || "Failed to fetch MFA preferences");
			}

			return data;
		} catch (error) {
			console.error("Error fetching MFA preferences:", error);
			throw error;
		}
	}

	/**
	 * @param {{ id: number, action: "enable" | "disable" }[]} users
	 * @returns {Promise<{ updated: { id: number, enabled: boolean }[], failed: { id: number, reason: string }[] }>}
	 */
	async updateMfaPreferences(users) {
		try {
			const response = await fetch(`${API_BASE}/users-mfa/toggle`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": window.wpApiSettings?.nonce || "",
				},
				credentials: "include",
				body: JSON.stringify({ users }),
			});

			const data = await response.json().catch(() => null);

			if (!response.ok) {
				throw new Error(data?.message || "Failed to update MFA preferences");
			}

			return data;
		} catch (error) {
			console.error("Error updating MFA preferences:", error);
			throw error;
		}
	}
}

export default new UsersMFAAPI();
